import {
  Home,
  Tirth,
  TirthDetail,
  Blogs,
  BlogDetail,
  AboutUs,
  ContactUs,
  Granth,
  GranthDetail,
} from "../pages";
import TermAndCondition from "../pages/Support/TermAndCondition";
import PrivacyPolicy from "../pages/Support/PrivacyPolicy";

export const routerConfig = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blogs",
    element: <Blogs />,
  },
  {
    path: "/about",
    element: <AboutUs />,
  },
  {
    path: "/granth",
    element: <Granth />,
  },
  {
    path: "/granth/:id",
    element: <GranthDetail />,
  },
  {
    path: "/article",
    element: <Granth path="article" type="literature" />,
  },
  {
    path: "/article/:id",
    element: <GranthDetail />,
  },
  {
    path: "/tirth",
    element: <Tirth />,
  },
  {
    path: "/tirth/:id",
    element: <TirthDetail />,
  },
  {
    path: "/blogs/:id",
    element: <BlogDetail />,
  },
  {
    path: "/contact",
    element: <ContactUs />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermAndCondition />,
  },
];
